export type LearnImageBinding = { id: string; slug: string; topic: string; alt: string; caption: string; src: string };
// The owner retired the old business-specific examples and their screenshots.
// Add a binding only after a separately selected replacement is qualified.
export const learnImageBindings: readonly LearnImageBinding[] = [];
